// flow weak

import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import Dialog from "material-ui/Dialog";
import styles from "./style";
import EventCalendar from "../../../components/EventCalendar/Calendar.new";
import { isMobile } from "react-device-detect";
import { Plus, Search } from "../../../icons";
import "./eventsTable.module.css";

import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
} from "../../../services/fetchTools";

class PartnerTournament extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      events: [],
      addnewseries: false,
      series_name: "",
      page: 1,
      total_pages: 0,
      loading: true,
      search_term: "",
      filtered_event: [],
      search: false,
      view_more: false,
    };

    this.onScroll = this.onScroll.bind(this);
    this.onChangeSearchTerm = this.onChangeSearchTerm.bind(this);
  }

  componentWillMount() {
    this.props.actions.enterPage("PartnerTournament");
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, false);
    this.getEventsList();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    clearTimeout(this.searchTimeout);
    this.props.actions.leavePage("PartnerTournament");
  }

  onChangeSearchTerm(e) {
    const value = e.target.value;
    const trimmedValue = value.trim().toLowerCase();

    if (trimmedValue.length === 0) {
      this.setState({
        search_term: value,
        search: false,
        filtered_event: [],
      });
      clearTimeout(this.searchTimeout);
      return;
    }

    const filtered = this.state.events.filter((event) => {
      const name = event.name ? event.name.toLowerCase() : "";
      const venue = event.venue ? event.venue.toLowerCase() : "";
      const format = event.game_format ? event.game_format.toLowerCase() : "";
      const organizer =
        event.organizer && event.organizer.length > 0
          ? event.organizer.join(", ").toLowerCase()
          : "";

      return (
        name.includes(trimmedValue) ||
        venue.includes(trimmedValue) ||
        format.includes(trimmedValue) ||
        organizer.includes(trimmedValue)
      );
    });

    this.setState({
      search_term: value,
      search: true,
      filtered_event: filtered,
    });

    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.searchEvents(trimmedValue);
    }, 300);
  }

  searchEvents(term) {
    var url =
      getLocationOrigin() +
      "/tournament/search?search=" +
      encodeURIComponent(term);

    fetch(url, defaultOptions)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        if (term === this.state.search_term.trim().toLowerCase()) {
          this.setState({ filtered_event: data.results });
        }
      })
      .catch(() => {});
  }

  onScroll() {
    if (this.state.loading) return;
    if (this.state.page >= this.state.total_pages) return;
    if (this.state.search) return;

    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 500
    ) {
      this.setState(
        { page: this.state.page + 1, loading: true },
        this.getEventsList,
      );
    }
  }

  getEventsList() {
    var url =
      getLocationOrigin() +
      "/tournament/list_events_for_cm/?page=" +
      this.state.page;

    fetch(url, defaultOptions)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        var events = this.state.events.slice();
        events = events.concat(data.events);

        this.setState({
          events: events,
          total_pages: data.total_pages,
          loading: false,
        });
      });
  }

  addNewSeries() {
    var url = getLocationOrigin() + "/eagleeye/add_new_series/";

    var options = Object.assign({}, defaultOptions);
    options.method = "post";
    options.headers = { "content-type": "application/json" };
    options.body = JSON.stringify({
      series_name: this.state.series_name,
    });

    fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        alert(data.message);
        this.setState({ addnewseries: false, series_name: "" });
      });
  }

  renderUpcomingEvents() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var upcomingEvents = this.state.events
      .filter(function (event) {
        if (!event.start_date) return false;
        var eventDate = new Date(event.start_date);
        eventDate.setHours(0, 0, 0, 0);
        return eventDate >= today;
      })
      .slice(0, 4);

    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div
          style={{
            ...styles.ep_events_card,
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h2 style={styles.ep_events_title}>Upcoming Events</h2>

          {upcomingEvents.length === 0 ? (
            <div style={styles.tournment_empty}>No upcoming events</div>
          ) : (
            <div style={styles.ep_events_list}>
              {upcomingEvents.map(function (event, idx) {
                return (
                  <div key={idx} style={styles.ep_event_item}>
                    <div style={styles.ep_event_main}>
                      <div style={styles.ep_event_date}>
                        {new Date(event.start_date).toLocaleDateString(
                          "en-US",
                          {
                            month: "short",
                            day: "numeric",
                          },
                        )}
                      </div>

                      <div style={styles.event_name_organiser_box}>
                        <div style={styles.ep_event_name}>{event.name}</div>
                        <span style={styles.ep_event_organizer}>
                          {event.organizer.join(", ")}
                        </span>
                      </div>
                    </div>

                    <div style={styles.ep_event_entries}>
                      {event.entries} Entries
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderAllEvents() {
    var events = this.state.search
      ? this.state.filtered_event
      : this.state.events;

    return (
      <div className="et-container">
        <div className="et-header">
          <h2 className="et-title">All Events</h2>
          <Link to="./crud/addTournaments">
            <button className="et-add-btn">
              <Plus width="15" height="15" /> Add Event
            </button>
          </Link>
        </div>

        <div className="et-search-wrapper">
          <div className="et-search-icon">
            <Search width="15" height="15" />
          </div>
          <input
            type="text"
            placeholder="Search events..."
            value={this.state.search_term}
            onChange={this.onChangeSearchTerm}
            className="et-search-input"
          />
          {this.state.search && this.state.loading && (
            <div className="et-search-spinner" />
          )}
        </div>

        <div className="et-table-wrapper">
          <table className="et-table">
            <thead>
              <tr>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Name</th>
                <th>Venue</th>
                <th>Format</th>
                <th>Organizer</th>
                <th className="et-center">Entries</th>
                <th className="et-center">Status</th>
              </tr>
            </thead>

            <tbody>
              {events && events.length > 0 ? (
                events
                  .map(function (eventItem) {
                    var start = eventItem.start_date
                      ? new Date(eventItem.start_date).toLocaleDateString(
                          "en-US",
                        )
                      : "-";

                    var end = eventItem.end_date
                      ? new Date(eventItem.end_date).toLocaleDateString("en-US")
                      : "-";

                    return (
                      <tr key={eventItem.id}>
                        <td>{start}</td>
                        <td>{end}</td>
                        <td className="et-name">
                          <Link to={"/crud/viewTournament/" + eventItem.id}>
                            {eventItem.name ? eventItem.name.slice(0, 40) : ""}
                          </Link>
                        </td>
                        <td>{eventItem.venue || "-"}</td>
                        <td>{eventItem.game_format || "-"}</td>
                        <td>
                          {eventItem.organizer && eventItem.organizer.length > 0
                            ? eventItem.organizer.join(", ")
                            : "-"}
                        </td>
                        <td className="et-center">
                          <span className="et-badge et-badge-indigo">
                            {eventItem.entries != null ? eventItem.entries : 0}
                          </span>
                        </td>
                        <td className="et-center">
                          <span
                            className={
                              "et-badge " +
                              (eventItem.is_visible
                                ? "et-badge-green"
                                : "et-badge-red")
                            }
                          >
                            {eventItem.is_visible ? "Published" : "Unpublished"}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                  .concat(
                    this.state.loading
                      ? Array.from({ length: 5 }).map(function (_, i) {
                          return (
                            <tr
                              key={"skeleton-" + i}
                              className="et-skeleton-row"
                            >
                              {Array.from({ length: 8 }).map(function (_, j) {
                                return (
                                  <td
                                    key={j}
                                    className={j >= 6 ? "et-center" : ""}
                                  >
                                    <div className="et-skeleton-cell" />
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })
                      : [],
                  )
              ) : this.state.loading ? (
                Array.from({ length: 7 }).map((_, i) => (
                  <tr key={"skeleton-" + i} className="et-skeleton-row">
                    {Array.from({ length: 8 }).map((_, j) => (
                      <td key={j} className={j >= 6 ? "et-center" : ""}>
                        <div className="et-skeleton-cell" />
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="8"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    Tournaments not found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    var seriesAction = [
      <div style={{ textAlign: "center" }}>
        <input
          type="button"
          className="button1"
          value="Submit"
          style={{ backgroundColor: "red", marginRight: "10px" }}
          onClick={this.addNewSeries.bind(this)}
        />
        <input
          type="button"
          className="button1"
          value="Cancel"
          onClick={() => this.setState({ addnewseries: false })}
        />
      </div>,
    ];

    return (
      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "stretch",
            gap: "16px",
          }}
        >
          <div style={{ flex: "0 0 33.333%", minWidth: 0 }}>
            <EventCalendar />
          </div>

          <div style={{ flex: 1, minWidth: 0 }}>
            {this.renderUpcomingEvents()}
          </div>
        </div>

        <div>
          {this.state.addnewseries && (
            <Dialog
              actions={seriesAction}
              modal={false}
              open={true}
              autoScrollBodyContent={true}
            >
              <div
                className="col-md-12"
                style={{ textAlign: isMobile ? "center" : "left" }}
              >
                <div className="col-md-6">Add New Series</div>

                <input
                  type="text"
                  className="col-md-6 required"
                  value={this.state.series_name}
                  onChange={(e) =>
                    this.setState({ series_name: e.target.value })
                  }
                />
              </div>
            </Dialog>
          )}
        </div>

        <div
          className="row hot_leads_pipeline"
          style={{ marginTop: "20px", paddingLeft: "5px", paddingRight: "5px" }}
        >
          {this.renderAllEvents()}
        </div>
      </div>
    );
  }
}

export default PartnerTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerTournament/PartnerTournament.js